var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon20Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-20-star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 20,
    height: 20,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M.161,6.2a.384.384,0,0,1-.144-.426l.064-.2A.391.391,0,0,1,.433,5.3L5.54,4.9,7.5.253A.408.408,0,0,1,7.906,0h.208a.392.392,0,0,1,.376.252L10.455,4.9l5.107.4a.391.391,0,0,1,.352.276l.064.2a.383.383,0,0,1-.12.426L12.006,9.466l1.183,4.9a.4.4,0,0,1-.152.418l-.232.126a.4.4,0,0,1-.448,0l-4.348-2.6L3.638,14.932a.4.4,0,0,1-.448,0l-.176-.118a.4.4,0,0,1-.152-.418l1.151-4.93Z",
    transform: "translate(2 2)",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20Star);
export default __webpack_public_path__ + "static/media/icon-20-star.adadc7b67285ca3ec0d5a18e880ea636.svg";
export { ForwardRef as ReactComponent };